import { i18n } from '@lingui/core'
import * as enUS from '../locales/en-US/messages'
import * as frFR from '../locales/fr-FR/messages'
import * as deDE from '../locales/de-DE/messages'
import * as esES from '../locales/es-ES/messages'
import * as ptPT from '../locales/pt-PT/messages'
import * as itIT from '../locales/it-IT/messages'
import * as ruRU from '../locales/ru-RU/messages'

export type SupportedLocale = 'en-US' | 'fr-FR' | 'de-DE' | 'es-ES' | 'pt-PT' | 'it-IT' | 'ru-RU'

const locateMessages = {
    'en-US': enUS.messages,
    'fr-FR': frFR.messages,
    'de-DE': deDE.messages,
    'es-ES': esES.messages,
    'pt-PT': ptPT.messages,
    'it-IT': itIT.messages,
    'ru-RU': ruRU.messages,
}

const LOCALE_STORAGE_KEY = 'locale'
const supportedLocales = ['en-US', 'fr-FR', 'de-DE', 'ru-RU', 'es-ES', 'pt-PT', 'it-IT'] as SupportedLocale[]
const defaultLocale = 'en-US' as SupportedLocale

// Определение начальной локали
const getInitialLocale = (): SupportedLocale => {
    // Проверяем, есть ли локаль в localStorage
    const storageLocale = localStorage.getItem(LOCALE_STORAGE_KEY) as SupportedLocale | null

    if (storageLocale && supportedLocales.includes(storageLocale)) {
        return storageLocale
    }

    // Если нет в localStorage, пробуем определить по языку браузера
    const browserLocale = navigator.language as SupportedLocale

    // Часто в браузере язык по умолчанию - английский и пользователь просто не меняет его
    if (browserLocale !== 'en-US' && supportedLocales.includes(browserLocale)) {
        return browserLocale
    }

    for (const locale of supportedLocales) {
        if (locale.startsWith(Intl.DateTimeFormat().resolvedOptions().locale)) {
            return locale
        }
    }

    return defaultLocale
}

let currentLocale = getInitialLocale()

i18n.load(currentLocale, locateMessages[currentLocale])
i18n.activate(currentLocale)

export const localeManager = {
    getCurrentLocale: () => currentLocale,
    getDefaultLocale: () => defaultLocale,

    setLocale: async (locale: SupportedLocale) => {
        if (locale === currentLocale) {
            return
        }

        i18n.load(locale, locateMessages[locale])
        i18n.activate(locale);

        localStorage.setItem(LOCALE_STORAGE_KEY, locale)

        currentLocale = locale
    },
}
